import { create } from 'zustand';

interface IUserStats {
  general_points: number;
  competition_points: number;
  referral_points: number;
  referral_count: number;
  total_leaderboard_position: number;
  weekly_leaderboard_position: number;
}

interface IUserData {
  id: string;
  tg_id: number;
  avatar_url: string;
  username: string;
  nickname: string;
  total_points: number;
  referral_count: number;
  referral_code: string;
  wallet_address: string | null;
  wallet_update_count: number;
  hints: number;
  lastQuizParticipation: string | Date;
  total_leaderboard_position: number;
  weekly_leaderboard_position: number;
  created_at: string;
  updated_at: string;
}

export interface IRootStore {
  user: IUserData | null;
  setUserData: (data: IUserData) => void;
  userStats: IUserStats | null;
  setUserStats: (data: IUserStats) => void;
  setWallet: (wallet: string) => void;
}

export const useRootStore = create<IRootStore>((set, get) => ({
  user: null,
  setUserData: (data: IUserData) => set({ user: data }),
  userStats: null,
  setUserStats: (stats: IUserStats) => set({ userStats: stats }),
  setWallet: (wallet: string) => {
    const user = get().user;

    set({
      user: user
        ? {
            ...user,
            wallet_address: wallet,
            wallet_update_count: user.wallet_update_count + 1,
          }
        : null,
    });
  },
}));
